import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField
} from "@mui/material";
import api from "../api";

export default function AdsList() {
  const [ads, setAds] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", type: "image", file: null });

  const fetchAds = async () => {
    const res = await api.get("/api.php?action=ads_list");
    console.log('res', res.data.data);
    setAds(res.data.data);
  };

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("type", form.type);
    if (form.file) formData.append("file", form.file);

    await api.post("/api.php?action=ads_create", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    setOpen(false);
    fetchAds();
  };

  const handleDelete = async (id) => {
    await api.delete(`/api.php?action=ads_delete/${id}`);
    fetchAds();
  };

  useEffect(() => {
    fetchAds();
  }, []);

  return (
    <div>
      <Button variant="contained" onClick={() => setOpen(true)}>
        Add Ad
      </Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Preview</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ads && ads.map((ad) => (
            <TableRow key={ad.id}>
              <TableCell>{ad.title}</TableCell>
              <TableCell>{ad.type}</TableCell>
              <TableCell>
                {ad.type === "image" ? (
                  <img src={ad.url} alt="" width={100} />
                ) : (
                  <video src={ad.url} width={150} controls />
                )}
              </TableCell>
              <TableCell>
                <Button onClick={() => handleDelete(ad.id)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Add Ad</DialogTitle>
        <DialogContent>
          <TextField
            label="Title"
            fullWidth
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />
          <TextField
            label="Type"
            fullWidth
            onChange={(e) => setForm({ ...form, type: e.target.value })}
          />
          <input
            type="file"
            onChange={(e) => setForm({ ...form, file: e.target.files[0] })}
          />
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
